export default __webpack_public_path__ + "static/media/F30-Digital-Banner.17524272.gif";